module.exports = __webpack_public_path__ + "img/left.6617c400.png";